"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Record = _interopRequireDefault(require("./tabItem/Record.vue"));
var _Supplier = _interopRequireDefault(require("./tabItem/Supplier.vue"));
var _Product = _interopRequireDefault(require("./tabItem/Product.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProductConfig',
  components: {
    RecordVue: _Record.default,
    SupplierVue: _Supplier.default,
    ProductVue: _Product.default
  },
  data: function data() {
    return {
      activeName: 'SupplierVue',
      dialogFormVisible: false,
      id: null
    };
  },
  methods: {
    open: function open(row) {
      this.id = row.id;
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.id = null;
      this.dialogFormVisible = false;
    }
  }
};